import { cva } from 'class-variance-authority';

export const cvaRoot = cva([
  'pricingBanner-cvaRoot',
  'flex items-center bg-main_dark_blue rounded-[2rem]  justify-between  relative',
  'overflow-hidden',
]);

export const cvaInfoContainer = cva([
  'pricingBanner-cvaInfoContainer',
  'flex flex-col items-start gap-4',
  'mr-[2rem] ml-[6rem]',
  'lg-max:ml-[3rem]',
  'md-max:py-[2rem]',
]);

export const cvaInfoTitle = cva([
  'pricingBanner-cvaInfoTitle',
  'ff-raleway font-bold text-[48px] leading-[56px] text-white',
  'md-max:text-[32px] md-max:leading-[40px]',
  'xs-max:text-[2rem] xs-max:leading-[36px]',
  'sm-max:text-[2.25rem]',
]);

export const cvaInfoDescription = cva([
  'pricingBanner-cvaInfoDescription',
  'ff-os-hebrew font-normal text-[24px] leading-[36px] text-white',
  'md-max:text-[20px] md-max:leading-[30px]',
  'xs-max:text-[18px] xs-max:leading-[28px]',
  'sm-max:text-[1.25rem]',
]);

export const cvaImage = cva(['pricingBanner-cvaImage', 'md-max:hidden']);
